

let language = {
STORE_PRODUCT_LIST_SEARCH_PLACEHOLDER:"Search",
STORE_PRODUCT_LIST_SYNCHRONOUS_BTN:"Synchronize",
STORE_PRODUCT_LIST_SYNC_BTN:"Sync",
STORE_PRODUCT_LIST_REMOVE_BTN:"Remove",
STORE_PRODUCT_LIST_COPY_BTN:"Copy",
STORE_PRODUCT_LIST_ADD_BTN:"Add",
STORE_PRODUCT_LIST_EDIT_BTN:"Edit",
STORE_PRODUCT_LIST_EDIT_PHOTO_LIB_BTN: "Edit card rarity",
STORE_PRODUCT_LIST_SAMPLE_ORDER_BTN:"ORDER SAMPLE",
STORE_PRODUCT_LIST_EDIT_PRICE_BTN:"Edit Pricing",
STORE_PRODUCT_LIST_EDIT_INFO_BTN:"Edit Product Info",
STORE_PRODUCT_LIST_EDIT_DESIGN_BTN:"Edit Design",
STORE_PRODUCT_LIST_RESOURCE_SETTING:"Library Setting",
STORE_PRODUCT_LIST_SEARCH_EMPTY_DES1:"To find the store product you are searching for, you can click",
STORE_PRODUCT_LIST_SEARCH_EMPTY_DES2:"here",
STORE_PRODUCT_LIST_SEARCH_EMPTY_DES3:"to see our Catalog and select the products you would like to offer your customers. ",
STORE_PRODUCT_LIST_HEAD_PRODUCT:"Product",
STORE_PRODUCT_LIST_HEAD_PRODUCT_STATUE:"Product Status",
STORE_PRODUCT_LIST_HEAD_SYNC_STATUE:"Synchronization Status",
STORE_PRODUCT_LIST_HEAD_ACTIONS:"Actions",
STORE_PRODUCT_LIST_FULL_PRODUCT_PROPERTY:"Full Product",
STORE_PRODUCT_LIST_PRODUCT_SYNCING:"Synchronizing",
STORE_PRODUCT_LIST_PRODUCT_SYNC_FAILED:"Synchronized failed",
STORE_PRODUCT_LIST_PRODUCT_SYNC_SUCCESS:"Synchronized",
STORE_PRODUCT_LIST_PRODUCT_NO_SYNC:"Not synchronized",
STORE_PRODUCT_LIST_PRODUCT_ACTIVE:"Active",
STORE_PRODUCT_LIST_PRODUCT_INACTIVE:"Inactive",
STORE_PRODUCT_LIST_PRODUCT_ACTIVE_BTN:"Activate",
STORE_PRODUCT_LIST_PRODUCT_DEACTIVATE_BTN:"Deactivate",
STORE_PRODUCT_LIST_PRODUCT_IMAGE_ERROR_TIP:"Your product mockup thumbnail loaded failed, you can click to reload the image again.",
    STORE_PRODUCT_LIST_PRODUCT_BTN_SHIPPING:"SHIPPING",
    STORE_PRODUCT_LIST_PRODUCT_BTN_LINK_PRODUCT:"Link Product",
    STORE_PRODUCT_LIST_PRODUCT_BTN_UNLINK_PRODUCT:"Unlink Product",
    STORE_PRODUCT_LIST_PRODUCT_BTN_EDIT_BINDING:"Edit Binding",
    STORE_PRODUCT_LIST_PRODUCT_BTN_EDIT_BINDING_VIEW_ETSY_STORE:"View Etsy Store Products",
    STORE_PRODUCT_LIST_PRODUCT_BTN_EDIT_BINDING_ETSY_PRODUCT_ID:"Etsy Product ID",
    STORE_PRODUCT_LIST_PRODUCT_ERROR_UNBINDING_ERROR_TITLE:"Unbinding error",
    STORE_PRODUCT_LIST_PRODUCT_ERROR_UNBINDING_ERROR_CONTENT:"Unbinding error",
    STORE_PRODUCT_LIST_PRODUCT_ERROR_UNBINDING_ERROR_CONTENT_1101173006:"The product does not exist",
    STORE_PRODUCT_LIST_PRODUCT_MODEL_UNBINDING_TITLE:"Are you sure you want to unlink the product?",
    STORE_PRODUCT_LIST_PRODUCT_MODEL_UNBINDING_LINKED_PRODUCT:"Linked Product",
    STORE_PRODUCT_LIST_PRODUCT_MODEL_UNBINDING_CANCEL:"CANCEL",
    STORE_PRODUCT_LIST_PRODUCT_MODEL_UNBINDING_CONFIRM:"CONFIRM",
    STORE_PRODUCT_LIST_PRODUCT_AUTHORIZATION_ALREADY:"Your authorization has expired. Please ",
    STORE_PRODUCT_LIST_PRODUCT_AUTHORIZATION_WILL:"Your authorization is about to expired. Please",
    STORE_PRODUCT_LIST_PRODUCT_REAUTHORIZE:"reauthorize",
    STORE_PRODUCT_LIST_PRODUCT_MODEL_YOUR_ACCOUNT:"your account.",
    
};

export { language }